import { inject, Injectable } from "@angular/core";
import { ClassService } from "./data-services/class.service";
import { ConfigService } from "./config.service";
import { TeacherToClassService } from "./data-services/teacher-to-class.service";
import { ClassCoordinatorService } from "./data-services/class-coordinator.service";
import { forkJoin, map } from "rxjs";
import { ClassState } from "../core/constants/class-state.enum";
import { RelationshipService } from "./data-services/relationship.service";
import { ClassCoordinator } from "../core/models/table-entities/class-coordinator.interface";

@Injectable({
  providedIn: 'root',
})
export class ContextService {

  private classService = inject(ClassService);
  private configService = inject(ConfigService);
  private teacherToClassService = inject(TeacherToClassService);
  private coordinatorService = inject(ClassCoordinatorService);
  private relationshipService = inject(RelationshipService);


  public loadAppContext() {
    console.log('[ContextService] App context being loaded');
    const userId = this.configService.getCurrentUserId();
    const teachingClasses$ = this.teacherToClassService.getRootEntities(userId);
    const coordinatingClasses$ = this.coordinatorService.getRootEntities(userId);
    const relationships$ = this.relationshipService.getChildrenOfUser(userId);
    return forkJoin([teachingClasses$, coordinatingClasses$, relationships$]).pipe(
      map(([teachingClasses, coordinatingClasses, children]) => {
        const userContext = this.configService.getUserContext();
        userContext.assignedClasses = teachingClasses.map(tc => this.classService.getItemById(tc.classId)).filter(c => c!.state !== ClassState.Completed).map(c => c!.id);
        userContext.coordinatedClasses = coordinatingClasses.filter(cc => this.isInsideCoordinationPeriod(cc)).map(cc => this.classService.getItemById(cc.classId)).filter(c => c!.state !== ClassState.Completed).map(c => c!.id);
        userContext.childrenIds = children.map(r => r.studentId);
      }));
  }

  private isInsideCoordinationPeriod(classCoordinator: ClassCoordinator) {
    const now = new Date();
    return now >= new Date(classCoordinator.startDate ?? '') && now <= new Date(classCoordinator.endDate ?? '');
  }
}
